import React from "react";

export default function Close({ clickHandler }) {
  return (
    <button type="button" onClick={() => clickHandler()} className="Close">
      <svg width="50pt" height="50pt" viewBox="0 0 50 50" version="1.1">
        <g id="surface36486">
          <path
            style={{
              stroke: "none",
              fillRule: "nonzero",
              fill: "rgb(100%,100%,100%)",
              fillOpacity: 1,
            }}
            d="M 35.578125 41.730469 L 8.269531 14.421875 C 7.5 13.460938 7.5 12.117188 8.269531 11.347656 L 11.347656 8.269531 C 12.117188 7.5 13.460938 7.5 14.421875 8.269531 L 41.730469 35.578125 C 42.5 36.347656 42.5 37.691406 41.730469 38.652344 L 38.652344 41.730469 C 37.882812 42.5 36.539062 42.5 35.578125 41.730469 Z M 35.578125 41.730469 "
          />
          <path
            style={{
              stroke: "none",
              fillRule: "nonzero",
              fill: "rgb(100%,100%,100%)",
              fillOpacity: 1,
            }}
            d="M 8.269531 35.578125 L 35.578125 8.269531 C 36.347656 7.5 37.691406 7.5 38.652344 8.269531 L 41.730469 11.347656 C 42.5 12.117188 42.5 13.460938 41.730469 14.421875 L 14.421875 41.730469 C 13.652344 42.5 12.308594 42.5 11.347656 41.730469 L 8.269531 38.652344 C 7.5 37.882812 7.5 36.539062 8.269531 35.578125 Z M 8.269531 35.578125 "
          />
        </g>
      </svg>
    </button>
  );
}
